export type PanelUsage = { mode_id: string; criticality: string; sex_specific?: string };

export type Panel = {
  panel_id: string;
  label: string;
  description?: string;
  source_type?: string;
  input_methods?: string[];
  recency_days?: number;
  biomarkers?: string[];
  completion_rule?: { type?: string; [k: string]: unknown };
  pending_action_on_change?: string | null;
  used_by?: PanelUsage[];
  biomarker_count?: number;
};

export type PanelsResponse = {
  version: number | string | null;
  last_updated: string | null;
  notes?: string;
  panels: Record<string, Panel>;
  baseline_panels: string[];
};

export function panelList(resp: PanelsResponse | undefined): Panel[] {
  if (!resp) return [];
  return Object.values(resp.panels ?? {});
}
